import { c as _c } from "react/compiler-runtime";
import type { UIMessage, UseChatHelpers } from '@ai-sdk/react';
import { useState, useEffect } from 'react';
import { useScrollToBottom } from './use-scroll-to-bottom';
export function useMessages(t0) {
  const $ = _c(16);
  const {
    chatUuid,
    status
  } = t0;
  const {
    containerRef,
    endRef,
    isAtBottom,
    scrollToBottom,
    onViewportEnter,
    onViewportLeave
  } = useScrollToBottom();
  const [hasSentMessage, setHasSentMessage] = useState(false);
  let t1;
  let t2;
  if ($[0] !== chatUuid || $[1] !== scrollToBottom) {
    t1 = () => {
      if (chatUuid) {
        scrollToBottom("instant");
        setHasSentMessage(false);
      }
    };
    t2 = [chatUuid, scrollToBottom];
    $[0] = chatUuid;
    $[1] = scrollToBottom;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== scrollToBottom || $[5] !== status) {
    t3 = () => {
      if (status === "submitted") {
        setHasSentMessage(true);
        setTimeout(() => {
          scrollToBottom("smooth");
        }, 500);
      }
    };
    t4 = [status, scrollToBottom];
    $[4] = scrollToBottom;
    $[5] = status;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== containerRef || $[9] !== endRef || $[10] !== hasSentMessage || $[11] !== isAtBottom || $[12] !== onViewportEnter || $[13] !== onViewportLeave || $[14] !== scrollToBottom) {
    t5 = {
      containerRef,
      endRef,
      isAtBottom,
      scrollToBottom,
      onViewportEnter,
      onViewportLeave,
      hasSentMessage
    };
    $[8] = containerRef;
    $[9] = endRef;
    $[10] = hasSentMessage;
    $[11] = isAtBottom;
    $[12] = onViewportEnter;
    $[13] = onViewportLeave;
    $[14] = scrollToBottom;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}